<template>
  <ChartLayout
    title="Funding amounts by type and stage"
    units="Median and mean funding amount, million USD"
  >
    <Chart
      :options="{
        ...chartOptions,
        series: fundingTypeSeries,
      }"
    />
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import fundingTypes from "../data/fundingTypes";
export default {
  components: {
    Chart,
    ChartLayout,
  },
  data() {
    /*
    const phases = fundingTypes.reduce(
      (phases, fundingType, i) => ({ ...phases, [fundingType.stage]: i + 1 }),
      {}
    );
    */
    return {
      fundingTypeSeries: fundingTypes.reduce((series, fundingType) => {
        const stageSeries = series.find(
          (series) => series.name === fundingType.stage
        );
        const dataPoint = {
          name: fundingType.name,
          low: fundingType.median,
          high: fundingType.average,
          options: {
            description: fundingType.description,
          },
        };
        if (!stageSeries) {
          series.push({
            name: fundingType.stage,
            data: [dataPoint],
          });
        } else {
          stageSeries.data.push(dataPoint);
        }
        return series;
      }, []),
      chartOptions: ChartOptions.buildOptions(
        {
          chart: {
            inverted: true,
            height: 600,
          },
          xAxis: {
            type: "category",
            /*
            plotBands: Object.keys(phases).map((phase, i) => ({
              from: i === 0 ? -1 : phases[Object.keys(phases)[i - 1]],
              to: phases[phase],
              label: {
                align: "center",
                verticalAlign: "top",
                y: 14,
                className: i % 2 ? "highcharts-nofill" : undefined,
                text: phase,
              },
            })),
            */
          },
          yAxis: {
            // type: "logarithmic",
            opposite: true,
            className: "highcharts-show-grid",
          },
          tooltip: {
            formatter: function () {
              return `<span class="highcharts-header">${this.point.series.name}</span><br>
              <b>${this.point.name}</b><br>
              Median: <b>${this.point.low} million USD</b><br>
              Mean: <b>${this.point.high} million USD</b><br>
              <p>${this.point.options.description}</p>`;
            },
          },
          plotOptions: {
            dumbbell: {
              marker: {
                enabled: true,
              },
              lineWidth: 4,
              dataLabels: {
                enabled: true,
                formatter: function () {
                  if (this.point.x === fundingTypes.length - 1) {
                    return this.point.y === this.point.low ? "Median" : "Mean";
                  }
                },
              },
            },
          },
        },
        "dumbbell"
      ),
    };
  },
};
</script>

<style>
path.highcharts-lollipop-stem {
  stroke: inherit !important;
  stroke-width: 2px;
}
</style>
